import { CheckInQuestionKey } from '../models/check-in-question';
import { CheckOutQuestionKey } from '../models/check-out-question';
import { HistoryType } from '../models/patient-history';
import { PatientPortalDataType } from '../models/patient-portal-data';
import { SnomedCategoryType } from '../models/snomed-category';

export enum AuthenticateStatus {
    LOCKED = 'Locked',
    INVALID = 'Invalid',
    ACTIVATE_ACCOUNT = 'Activate_Account',
    VALID = 'Valid',
    ONE_PATIENT = 'One_Patient',
    VERIFY_EMAIL = 'Verify_Email',
    VERIFY_PHONE = 'Verify_Phone',
    PASSWORD_EXPIRED = 'Password_Expired',
}

export enum ResetPasswordStatus {
    CREATE_PASSWORD = 'Create_Password',
    EXPIRED = 'Expired',
    RESET_PASSWORD = 'Reset_Password',
    NONE = 'None'
}

export const checkInQuestionKeys: CheckInQuestionKey[] = [
    CheckInQuestionKey.Demographic,
    CheckInQuestionKey.EmergencyContact,
    CheckInQuestionKey.Pharmacy,
    CheckInQuestionKey.Insurance,
    CheckInQuestionKey.TelehealthVisit,
    CheckInQuestionKey.VisitReason,
    CheckInQuestionKey.VitalSign,
    CheckInQuestionKey.PastMedicalHistory,
    CheckInQuestionKey.Allergy,
    CheckInQuestionKey.Medication,
    CheckInQuestionKey.FamilyHistory,
    CheckInQuestionKey.SocialHistory,
    CheckInQuestionKey.Thanks
];

export const checkOutQuestionKeys: CheckOutQuestionKey[] = [
    CheckOutQuestionKey.Payment,
    CheckOutQuestionKey.PaymentSucceeded,
    CheckOutQuestionKey.Followup,
    CheckOutQuestionKey.Completed,
    CheckOutQuestionKey.Finished,
    CheckOutQuestionKey.Completed
];

export enum KeyCode {
    TAB = 9,
    UP_ARROW = 38,
    DOWN_ARROW = 40,
    ENTER = 13,
    BACKSPACE = 8,
    DELETE = 46
}

export const historyTypeToPatientPortalDataType = {
    [HistoryType.PastMedicalHistory]: PatientPortalDataType.PastMedicalHistory,
    [HistoryType.FamilyHistory]: PatientPortalDataType.FamilyHistory,
    [HistoryType.SocialHistory]: PatientPortalDataType.SocialHistory,
    [HistoryType.SmokingHistory]: PatientPortalDataType.SmokingHistory,
    [HistoryType.DrinkingHistory]: PatientPortalDataType.DrinkingHistory,
    [HistoryType.DrugHistory]: PatientPortalDataType.DrugAbuseHistory,
    [HistoryType.FallHistory]: PatientPortalDataType.FallHistory
} as Dictionary<PatientPortalDataType>;

export const historyTypeToSnomedCategoryType = {
    [HistoryType.DrugHistory]: SnomedCategoryType.DrugAbuseHistory,
    [HistoryType.FallHistory]: SnomedCategoryType.FallHistory
};

export enum TimeFrameUnitType {
    Scheduled = 0,
    Now = 10,
    Day = 20,
    Week = 30,
    Month = 40,
    Year = 55
}

export const TimeFrameUnitTypeName = {
    0: 'scheduled',
    10: 'now',
    20: 'day',
    30: 'week',
    40: 'month',
    55: 'year'
};

export const emptyFunction = () => ({});
